import { DependencyList, useEffect } from 'react';
import { useNotificationAlertContext } from '@/core/providers/SystemAlertContext';

export interface UseSystemAlertOptions {
  clearOnUnmount?: boolean;
  dependencies: DependencyList;
  title?: string;
  condition: () => boolean;
  description: string | JSX.Element;
}

function useSystemAlert(hookOptions: UseSystemAlertOptions) {
  const { condition, dependencies, clearOnUnmount = true } = hookOptions;
  const { setIsSystemAlertActive, setContextSystemAlertOptions } = useNotificationAlertContext();

  useEffect(() => {
    if (condition()) {
      setContextSystemAlertOptions(hookOptions);
      setIsSystemAlertActive(true);
    } else {
      setIsSystemAlertActive(false);
    }
  }, dependencies);

  useEffect(() => {
    return () => {
      if (clearOnUnmount && condition()) {
        setIsSystemAlertActive(false);
      }
    };
  }, []);
}

export default useSystemAlert;
